module.exports = "<div id=\"video-popup\" class=\"flash-player lightbox lightbox-frame\">\n    <div class=\"heading\">\n        <h3><%= title %></h3>\n    </div>\n    <div class=\"video-player-wrapper\">\n        <div id=\"video-player\">\n            <div id=\"playerHolder\">\n                <iframe height=\"435\" frameBorder=\"0\" scrolling=\"no\" src=\"<%= url %>\" width=\"665\"><%= i18n.loadingDDD %></iframe>\n            </div>\n        </div>\n    </div>\n    <div class=\"clear\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./js/common/templates/media/FlashMediaPopup.html
// module id = 1077
// module chunks = 26 27 28